import React, { useState } from "react"
import { Form, message } from "antd"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';

import { ROUTES, COMMON_FEATURES } from "../../../../../../../constants"

// Components
import showSecondarySidebar from "../../../../../../../layout/MainLayout/helpers/showSecondarySidebar"
import Page from "../../../../../../../components/Decoration/Page"
import VehicleIssueForm from "./VehicleIssueForm"

import { v3_vamVehicleIssues } from '../../../../../../../services/redux/actions'

// Services
import { REDUX } from '../../../../../../../services/util'

// Style

const VehicleIssueAdd = () => {

    const [ form ] = Form.useForm()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [messageApi, contextHolder] = message.useMessage();

    const { uid } = useSelector(REDUX.reduxStoreWrapper('user'))
    const vamlid = useSelector(REDUX.reduxStoreWrapper('vamLines.selectedVAMLID'))

    const [images, setImages] = useState([])

    const onFinish = e => {
        const items = { ...e }; 
        delete items.photos; 

        messageApi.open({
            type: "loading",
            content: "Creating new vehicle issue...",
            duration: 0,
          });

        dispatch(v3_vamVehicleIssues.cu_vam_vehicle_issue_request({ action: 'C', issue: { vamlid, status: 'VAMI000', ...items, ...(images?.length ? { photos: images } : {})}, uid }, 
        () => {messageApi.destroy(); navigate(ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.VEHICLE_ISSUES_MANAGEMENT])}))
    }

    const items = { form, onFinish, images, setImages }

    return (
        <div className="page-container">
            {contextHolder}
            <Page title="Add New Vehicle Issue">
                <VehicleIssueForm {...items}/>
            </Page>
        </div>
    )
}

const MemoizedVehicleIssueAdd = React.memo(VehicleIssueAdd);

export default showSecondarySidebar(false)(MemoizedVehicleIssueAdd);